module.exports = "<div class=\"load8\">\n  <div class=\"loader\">\n  </div>\n</div>\n"